import { IntroScreenType } from 'game-ui-types'
import { configTypeA } from './configTypeA'
import { configTypeB } from './configTypeB'

export const configs = {
    [IntroScreenType.INTRO_SCREEN_CONFIG_A]: configTypeA,
    [IntroScreenType.INTRO_SCREEN_CONFIG_B]: configTypeB,
}
